import React, { useEffect, useRef } from 'react';
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const WhyOnlineUmrah = () => {

    const swiperRef = useRef(null);

    // Swiper initialization with options
    useEffect(() => {
        if (swiperRef.current) {
            const swiper = new Swiper(swiperRef.current, {
                modules: [Navigation, Pagination, Autoplay],
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.slider-next',
                    prevEl: '.slider-prev',
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                spaceBetween: 20,
                breakpoints: {
                    0: { slidesPerView: 1 },
                    767: { slidesPerView: 2, centeredSlides: true },
                    992: { slidesPerView: 2, centeredSlides: true },
                    1200: { slidesPerView: 2, centeredSlides: true },
                    1400: { slidesPerView: 3, centeredSlides: true },
                },
                loop: true,
            });

            return () => {
                if (swiper) swiper.destroy();
            };
        }
    }, []);

    return (
        <>
            <section className="testi-area overflow-hidden space pb-0" id="testi-sec">
                <div className="container-fluid p-0">
                    <div className="title-area mb-20 text-center">
                        <h2 className="sec-title">Why Online Umrah Is Best</h2>
                    </div>
                    <div className="slider-area">
                        <div
                            className="swiper th-slider testiSlider1 has-shadow"
                            id="testiSlider1"
                            ref={swiperRef}
                        >
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <div className="testi-card">
                                        <div className="testi-card_wrapper">
                                            <div className="testi-card_profile">
                                                <div className="testi-card_avater">
                                                    <img
                                                        src="/assets_web/img/logo/onlineumra_logo_01.svg"
                                                        alt="onlineumra_logo"
                                                    />
                                                </div>
                                                <div className="media-body">
                                                    <h3 className="box-title">Privately Owned Umrah Packages</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="testi-card_text">
                                            The professional & highly experienced team of the site provide Private Umrah Tours with multilingual guide benefit.
                                        </p>
                                        <div className="testi-card-quote">
                                            <img src="/assets_web/img/icon/testi-quote.svg" alt="img" />
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="testi-card">
                                        <div className="testi-card_wrapper">
                                            <div className="testi-card_profile">
                                                <div className="testi-card_avater">
                                                    <img
                                                        src="/assets_web/img/logo/onlineumra_logo_02.svg"
                                                        alt="onlineumra_logo"
                                                    />
                                                </div>
                                                <div className="media-body">
                                                    <h3 className="box-title">Hassle-Free Booking & Payment</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="testi-card_text">
                                            Get the most out of easy to make online payment and booking of preferred Umrah Packages.
                                        </p>
                                        <div className="testi-card-quote">
                                            <img src="/assets_web/img/icon/testi-quote.svg" alt="img" />
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="testi-card">
                                        <div className="testi-card_wrapper">
                                            <div className="testi-card_profile">
                                                <div className="testi-card_avater">
                                                    <img
                                                        src="/assets_web/img/logo/onlineumra_logo_03.svg"
                                                        alt="onlineumra_logo"
                                                    />
                                                </div>
                                                <div className="media-body">
                                                    <h3 className="box-title">Sought After Luxury Arrangements</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="testi-card_text">
                                            Things like Accommodation, Transportation and Private Umrah Tours are offered.
                                        </p>
                                        <div className="testi-card-quote">
                                            <img src="/assets_web/img/icon/testi-quote.svg" alt="img" />
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="testi-card">
                                        <div className="testi-card_wrapper">
                                            <div className="testi-card_profile">
                                                <div className="testi-card_avater">
                                                    <img
                                                        src="/assets_web/img/logo/onlineumra_logo_04.svg"
                                                        alt="onlineumra_logo"
                                                    />
                                                </div>
                                                <div className="media-body">
                                                    <h3 className="box-title">Make Your Own Package</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="testi-card_text">
                                            Create your own preferred umrah tour with the advent of our customized Umrah package options
                                        </p>
                                        <div className="testi-card-quote">
                                            <img src="/assets_web/img/icon/testi-quote.svg" alt="img" />
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="testi-card">
                                        <div className="testi-card_wrapper">
                                            <div className="testi-card_profile">
                                                <div className="testi-card_avater">
                                                    <img
                                                        src="/assets_web/img/logo/onlineumra_logo_05.svg"
                                                        alt="onlineumra_logo"
                                                    />
                                                </div>
                                                <div className="media-body">
                                                    <h3 className="box-title">Comfortable Transportation</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="testi-card_text">
                                            Experience trouble free way to transport visa Deluxe and Luxury Cars or an air-conditioned private coach.
                                        </p>
                                        <div className="testi-card-quote">
                                            <img src="/assets_web/img/icon/testi-quote.svg" alt="img" />
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="testi-card">
                                        <div className="testi-card_wrapper">
                                            <div className="testi-card_profile">
                                                <div className="testi-card_avater">
                                                    <img
                                                        src="/assets_web/img/logo/onlineumra_logo_06.svg"
                                                        alt="onlineumra_logo"
                                                    />
                                                </div>
                                                <div className="media-body">
                                                    <h3 className="box-title">Multi-Cuisine Dining</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="testi-card_text">
                                            Enjoy mouth-water pleasure of multi-cuisine dishes
                                        </p>
                                        <div className="testi-card-quote">
                                            <img src="/assets_web/img/icon/testi-quote.svg" alt="img" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="slider-pagination" /> */}
                            <div className="swiper-pagination" />
                        </div>
                    </div>
                </div>
                <div
                    className="shape-mockup d-none d-xl-block"
                    data-bottom="-2%"
                    data-right="0%"
                >
                    <img src="/assets_web/img/shape/line2.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup movingX d-none d-xl-block"
                    data-top="30%"
                    data-left="5%"
                >
                    <img src="/assets_web/img/shape/shape_7.png" alt="shape" />
                </div>
            </section>

        </>
    )
}

export default WhyOnlineUmrah
